import React, { Component } from "react";
import { DataTable } from "primereact/components/datatable/DataTable";
import { Column } from "primereact/components/column/Column";
//import { ProgressSpinner } from "primereact/components/progressspinner/ProgressSpinner";
import { Button } from "primereact/components/button/Button";
import { Growl } from "primereact/components/growl/Growl";
import { Dialog } from "primereact/components/dialog/Dialog";

//Imports from common
import { api } from "../../common/CloudService/ApiPromisify";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import { LoadScreen } from "../Common/LoadScreen";
//import { formatId } from "../../common/FormatId";

export class ClientLocations extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      test: "",
      locationList: [],
      locationSelected: false,
      locationEdited: false,
      locationAdded: false,
      locationDeleted: false,
      selectedLocation: "",
      locationBuildingId: "",
      locationClientId: "",
      locationCodeTag: "",
      locationId: "",
      locationLastUpdatedDateTime: "",
      locationName: "",
      locationUserId: "",
      locationTelephone: "",
      locationEmail: "",
      locationFloor: "",
      locationArea: "",
      editedLocationName: "",
      editedLocationFloor: "",
      editedLocationArea: "",
      editedLocationTelephone: "",
      editedLocationEmail: ""
    };
  }

  componentDidMount() {
    this.getLocations();
  }

  getLocations = async () => {
    this.setState({ loaded: false });

    let locationRequest = new CloudService.LocationRequest();
    locationRequest.codeTag = localStorage.getItem("codeTag");
    locationRequest.userId = localStorage.getItem("userId");
    locationRequest.buildingId = localStorage.getItem("buildingId");

    await api("locationApiV1LocationGetByBuildingId", locationRequest).then(
      res => {
        let locationResponse = CloudService.LocationResponse.constructFromObject(
          res.data
        );
        console.log(locationResponse);

        if (locationResponse.errorCode === 0) {
          this.setState({
            locationList: locationResponse.locationList
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "An error occured retrieving data, please refresh and try again",
            life: 3000
          });
        }
      }
    );

    this.setState({ loaded: true });
  };

  editLocation = async () => {
    this.setState({ loaded: false });

    let locationRequest = new CloudService.LocationRequest();
    locationRequest.codeTag = localStorage.getItem("codeTag");
    locationRequest.userId = localStorage.getItem("userId");
    locationRequest.id = this.state.locationId;
    locationRequest.lastUpdatedDateTime = this.state.locationLastUpdatedDateTime;
    locationRequest.name = this.state.editedLocationName;
    locationRequest.floor = this.state.editedLocationFloor;
    locationRequest.area = this.state.editedLocationArea;
    locationRequest.telephone = this.state.editedLocationTelephone;
    locationRequest.email = this.state.editedLocationEmail;

    await api("locationApiV1LocationUpdate", locationRequest).then(res => {
      let locationResponse = CloudService.LocationResponse.constructFromObject(
        res.data
      );
      console.log(locationResponse);

      if (locationResponse.errorCode === 0) {
        this.setState({
          locationEdited: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Location successfully updated",
          life: 3000
        });
        this.getLocations();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured updating the location, please try again",
          life: 3000
        });
      }
    });
  };

  addLocation = async () => {
    this.setState({ loaded: false });

    let locationRequest = new CloudService.LocationRequest();
    locationRequest.codeTag = localStorage.getItem("codeTag");
    locationRequest.userId = localStorage.getItem("userId");
    locationRequest.clientId = localStorage.getItem("clientId");
    locationRequest.siteId = localStorage.getItem("siteId");
    locationRequest.buildingId = localStorage.getItem("buildingId");
    locationRequest.name = this.state.editedLocationName;
    locationRequest.floor = this.state.editedLocationFloor;
    locationRequest.area = this.state.editedLocationArea;
    locationRequest.telephone = this.state.editedLocationTelephone;
    locationRequest.email = this.state.editedLocationEmail;

    await api("locationApiV1LocationCreate", locationRequest).then(res => {
      let locationResponse = CloudService.LocationResponse.constructFromObject(
        res.data
      );
      console.log(locationResponse);

      if (locationResponse.errorCode === 0) {
        this.setState({
          locationEdited: false,
          locationAdded: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Location successfully created",
          life: 3000
        });
        this.getLocations();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured creating the location, please try again",
          life: 3000
        });
      }
    });
  };

  deleteLocation = async () => {
    this.setState({ loaded: false });

    let locationRequest = new CloudService.LocationRequest();
    locationRequest.codeTag = localStorage.getItem("codeTag");
    locationRequest.userId = localStorage.getItem("userId");
    locationRequest.id = this.state.locationId;
    locationRequest.lastUpdatedDateTime = this.state.locationLastUpdatedDateTime;

    await api("locationApiV1LocationDelete", locationRequest).then(res => {
      let locationResponse = CloudService.LocationResponse.constructFromObject(
        res.data
      );
      console.log(locationResponse);

      if (locationResponse.errorCode === 0) {
        this.setState({
          locationSelected: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Location successfully deleted",
          life: 3000
        });
        this.getLocations();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured deleting the location, please try again",
          life: 3000
        });
      }
    });
  };

  render() {
    return (
      <div className="ui-g dashboard">
        <Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />
        <Dialog
          header="Delete Location"
          footer={
            <div>
              <Button
                label="Yes"
                onClick={() => {
                  this.setState({ locationDeleted: false });
                  this.deleteLocation();
                }}
                style={{
                  float: "right",
                  color: "white",
                  backgroundColor: "#01a4ef"
                }}
              />
              <Button
                label="No"
                onClick={() => {
                  this.setState({ locationDeleted: false });
                }}
                style={{
                  float: "right",
                  color: "white",
                  backgroundColor: "#808080"
                }}
              />
            </div>
          }
          visible={this.state.locationDeleted}
          style={{ width: "50vw" }}
          modal={true}
          onHide={e => this.setState({ locationDeleted: false })}
        >
          Are you sure you want to delete?
        </Dialog>
        {this.state.loaded === false ? (
          <LoadScreen />
        ) : (
          <div className="ui-g-12">
            {/*Locations Card*/}
            {this.state.locationSelected === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Location Name: </b>
                    <label>{this.state.locationName || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Floor Number: </b>
                    <label>{this.state.locationFloor || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Area: </b>
                    <label>{this.state.locationArea || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Contact Telephone: </b>
                    <label>{this.state.locationTelephone || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    {/*Empty div for spacing*/}
                    <label />
                  </div>
                  <div className="ui-g-4">
                    <b>Email: </b>
                    <label>{this.state.locationEmail || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <Button
                    label="Edit"
                    onClick={() => {
                      this.setState({
                        locationSelected: false,
                        locationEdited: true,
                        locationAdded: false,
                        editedLocationName: this.state.locationName,
                        editedLocationFloor: this.state.locationFloor,
                        editedLocationArea: this.state.locationArea,
                        editedLocationTelephone: this.state.locationTelephone,
                        editedLocationEmail: this.state.locationEmail
                      });
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    label="Delete"
                    onClick={() => {
                      this.setState({ locationDeleted: true });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Editing Locations Card*/}
            {this.state.locationEdited === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedLocationName === "" ||
                          this.state.editedLocationName === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedLocationName || ""}
                        onChange={e =>
                          this.setState({
                            editedLocationName: e.target.value
                          })
                        }
                      />
                      <label>Location Name *</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedLocationFloor === "" ||
                          this.state.editedLocationFloor === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedLocationFloor || ""}
                        onChange={e =>
                          this.setState({
                            editedLocationFloor: e.target.value
                          })
                        }
                      />
                      <label>Floor Number</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedLocationArea === "" ||
                          this.state.editedLocationArea === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedLocationArea || ""}
                        onChange={e =>
                          this.setState({
                            editedLocationArea: e.target.value
                          })
                        }
                      />
                      <label>Area</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedLocationTelephone === "" ||
                          this.state.editedLocationTelephone === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedLocationTelephone || ""}
                        onChange={e =>
                          this.setState({
                            editedLocationTelephone: e.target.value
                          })
                        }
                      />
                      <label>Contact Telephone</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    {/*Empty div for spacing*/}
                    <label />
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedLocationEmail === "" ||
                          this.state.editedLocationEmail === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedLocationEmail || ""}
                        onChange={e =>
                          this.setState({ editedLocationEmail: e.target.value })
                        }
                      />
                      <label>Email</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <Button
                    label="Save"
                    onClick={() => {
                      this.state.locationAdded === true
                        ? this.addLocation()
                        : this.editLocation();
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    label="Cancel"
                    onClick={() => {
                      this.state.locationAdded === true
                        ? this.setState({
                            locationSelected: false,
                            locationEdited: false,
                            locationAdded: false
                          })
                        : this.setState({
                            locationSelected: true,
                            locationEdited: false,
                            locationAdded: false
                          });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Locations Table*/}
            <div className="ui-g-12 card">
              <DataTable
                value={this.state.locationList}
                selectionMode="single"
                onSelectionChange={e => {
                  this.setState(
                    {
                      locationSelected: true,
                      locationEdited: false,
                      locationAdded: false,
                      selectedLocation: e.data,
                      locationBuildingId: e.data.buildingId,
                      locationClientId: e.data.clientId,
                      locationCodeTag: e.data.codeTag,
                      locationId: e.data.id,
                      locationLastUpdatedDateTime: e.data.lastUpdatedDateTime,
                      locationName: e.data.name,
                      locationUserId: e.data.userId,
                      locationTelephone: e.data.telephone,
                      locationEmail: e.data.email,
                      locationFloor: e.data.floor,
                      locationArea: e.data.area
                    },
                    () => {
                      console.log(this.state.selectedLocation);
                    }
                  );
                }}
                header="Locations"
                autoLayout={true}
                paginator={true}
                alwaysShowPaginator={true}
                rows={10}
                emptyMessage="No Locations"
              >
                <Column
                  field="name"
                  header="Location Name"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="telephone"
                  header="Contact Telephone"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="email"
                  header="Email"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
              </DataTable>
            </div>
            <div className="ui-g-12">
              <Button
                label="Create New"
                onClick={() => {
                  this.setState({
                    locationSelected: false,
                    locationEdited: true,
                    locationAdded: true,
                    editedLocationName: "",
                    editedLocationFloor: "",
                    editedLocationArea: "",
                    editedLocationTelephone: "",
                    editedLocationEmail: ""
                  });
                }}
                style={{ float: "right" }}
              />
              <Button
                className="secondary-btn"
                label="Back"
                onClick={() => {
                  window.location = "#/clientBuildings";
                }}
                style={{ float: "right" }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Clients/ClientLocations.js